import CandidateBoardCard from './CandidateBoardCard.component';

export default CandidateBoardCard;
